.skillsExplorerWrapper {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
}

.breadcrumb {
  background: var(--paletteBlue0);
  margin: 0;
  padding: 8px 10px;
  width: 100%;

  li {
    display: inline-block;
    margin-right: 8px;

    &::after {
      margin-left: 8px;
      content: "/";
      color: var(--paletteWhite0);
      display: inline-block;
    }

    &:last-of-type {
      &::after {
        display: none;
      }
    }
  }

  button {
    background: none;
    border: none;
    color: var(--paletteWhite0);
    cursor: pointer;
    font-weight: 500;

    &:hover {
      text-decoration: underline;
    }
  }
}

.skillsDrilldownSkillList {
  overflow-y: auto;
  animation: 0.8s ease-out 0s 1 slideIn;
}

@keyframes slideIn {
  0% {
    transform: translate(0, 40px);
    opacity: 0;
  }

  100% {
    transform: translate(0, 0);
    opacity: 1;
  }
}
